import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_PROVINCE, EDIT_PROVINCE, CREATE_PROVINCE } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteProvince(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_PROVINCE}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editProvince(prevData, searchParams, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_PROVINCE}`, {
    id: prevData?.id,
    title: prevData?.title,
    countryId: searchParams.get("id")
  }, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createProvince(prevData, searchParams, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_PROVINCE}`, {
    title: prevData?.title,
    countryId: searchParams.get("id")
  }, configReq(token));
}
